export const maskEmail = (email: string) => {
  const [username, domain] = email.split('@');
  return `${username.slice(0, 3)}*****@${domain.slice(-3)}`;
};

export const replaceNonDigit = (s: string) => s.replace(/\D/g, '');
